/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleLastSynchronizedAtUpdate
 */
export interface VehicleLastSynchronizedAtUpdate {
    /**
     * The last time the vehicle has been synced with the server.
     * @type {Date}
     * @memberof VehicleLastSynchronizedAtUpdate
     */
    lastSynchronizedAt: Date;
}

/**
 * Check if a given object implements the VehicleLastSynchronizedAtUpdate interface.
 */
export function instanceOfVehicleLastSynchronizedAtUpdate(value: object): value is VehicleLastSynchronizedAtUpdate {
    if (!('lastSynchronizedAt' in value) || value['lastSynchronizedAt'] === undefined) return false;
    return true;
}

export function VehicleLastSynchronizedAtUpdateFromJSON(json: any): VehicleLastSynchronizedAtUpdate {
    return VehicleLastSynchronizedAtUpdateFromJSONTyped(json, false);
}

export function VehicleLastSynchronizedAtUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleLastSynchronizedAtUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSynchronizedAt': (new Date(json['lastSynchronizedAt'])),
    };
}

export function VehicleLastSynchronizedAtUpdateToJSON(json: any): VehicleLastSynchronizedAtUpdate {
    return VehicleLastSynchronizedAtUpdateToJSONTyped(json, false);
}

export function VehicleLastSynchronizedAtUpdateToJSONTyped(value?: VehicleLastSynchronizedAtUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastSynchronizedAt': value['lastSynchronizedAt'].toISOString(),
    };
}

